"use client";
import { useFormattedDate } from "@/hooks/useFormatedData";
import { useLanguageStore } from "@/providers/useLanguageStore";
import React from "react";
import useReferralStore from "@/providers/useReferralStore";
import { generateLinkWithParams } from "@/utils/generateLinkWithParams";
import { normalizeClassroom } from "@/utils/normalizeClassroom";
import { useSearchParams } from "next/navigation";
import { getUtmParams } from "@/utils/getUtmParams";
import { resolveUtmParams } from "@/utils/utmStorage";

interface Schedule {
  day: string;
  since: string;
  to: string;
}
interface CareerItemProps {
  career: {
    _id: string;
    course: string;
    classroom: string;
    schedule: Schedule[];
    initialDate: string;
    coverThumbnail: string;
    slackChannel?: string;
    plan: string;
    mode?: string;
    officeLocation?: string;
    careerData?: {
      name?: string;
      description?: string;
      durationMonths?: number;
    };
    planData?: {
      _id: string;
      name: string;
      promoName?: string;
      promoPercentage?: number;
      priceSchema: number[];
    };
  };
  goToSubriptionPage?: boolean;
}
import CardLiveCourseItems from "../Shared/CardLiveCourseItems";

const CareerItem: React.FC<CareerItemProps> = ({ career, goToSubriptionPage }) => {
  const { translations } = useLanguageStore();
  const formattedDate = useFormattedDate(career.initialDate);
  const { referer, medium } = useReferralStore();
  const searchParams = useSearchParams();
  const currentUtmParams = getUtmParams(searchParams);
  const utmParams = resolveUtmParams(currentUtmParams);
  const normalizedClassroom = normalizeClassroom(career.classroom);
  const checkoutUrl = generateLinkWithParams(
    `https://inscripciones.rollingcodeschool.com/live-courses/checkout/new/${normalizedClassroom}`,
    referer,
    medium,
    utmParams
  );
  return (
    <CardLiveCourseItems
      type="career"
      item={career}
      translations={translations}
      formattedDate={formattedDate}
      normalizedClassroom={normalizedClassroom}
      checkoutUrl={checkoutUrl}
      goToSubriptionPage={goToSubriptionPage}
    />
  );
};
export default CareerItem;
